import React from 'react';

import PropTypes from 'prop-types';
import { HiChevronRight } from 'react-icons/hi';
import { IoHome } from 'react-icons/io5';
import { Link, Route } from 'react-router-dom';

import { BreadedContext } from './Breadcrumb';
import PopUp from './PopUp';

// const BreadedContext = React.createContext();

const MobileNav = ({ paths }) => {
  if (paths?.length > 2) {
    const { 0: first, length: l, [l - 1]: last } = paths;
    const middle_paths = paths.slice(1, -1);

    return (
      <>
        <Link className="text-sm font-semibold capitalize" to={first?.url}>
          {first?.label}
        </Link>
        {middle_paths?.length > 0 && (
          <>
            <HiChevronRight className="h-4 w-4" />
            <PopUp
              autoClose
              positionClassName="mt-2 -ml-4"
              buttonClassName="flex items-center gap-3"
              sizeClassName="w-52"
              render={
                <span className="block md:hidden text-sm font-black tracking-wide">
                  ...
                </span>
              }
              containerClassName="w-5"
            >
              {middle_paths?.map((x) => (
                <div className="py-1" role="none" key={`${x?.url}-${x?.label}`}>
                  <Link
                    to={x.url}
                    className="group flex items-center w-full text-left px-3 py-1 capitalize text-gray-800 gap-2 font-medium"
                  >
                    {x.label}
                  </Link>
                </div>
              ))}
            </PopUp>
            <HiChevronRight className="h-4 w-4" />
          </>
        )}
        <Link className="text-sm font-semibold" to={last?.url}>
          {last?.label}
        </Link>
      </>
    );
  }
  return paths.map((x, i) => (
    <React.Fragment key={`${x?.url}-${x?.label}`}>
      {i > 0 && <HiChevronRight className="h-4 w-4" />}
      <Link className="text-sm font-semibold capitalize" to={x.url}>
        {x.label}
      </Link>
    </React.Fragment>
  ));
};

MobileNav.defaultProps = {
  paths: [],
};

MobileNav.propTypes = {
  paths: PropTypes.instanceOf(Array),
};

export const BreadNav = () => {
  const { path } = React.useContext(BreadedContext);
  const paths = React.useMemo(() => {
    const list = Object.keys(path)
      .sort((a, b) => a.length - b.length)
      .map((key) => ({
        url: key,
        label: path[key],
      }));
    return list;
  }, [path]);

  return (
    <div className="flex items-center text-gray-700 gap-1">
      <Link to="/">
        <IoHome className="h-4 w-4 text-primary-500" />
      </Link>
      <HiChevronRight className="h-4 w-4" />
      <div className="hidden md:flex items-center gap-1">
        {paths.map((x, i) => (
          <React.Fragment key={`${x?.url}-${x?.label}`}>
            {i > 0 && <HiChevronRight className="h-4 w-4" />}
            <Link className="text-sm font-semibold" to={x.url}>
              {x.label}
            </Link>
          </React.Fragment>
        ))}
      </div>
      <div className="flex md:hidden gap-1 items-center">
        <MobileNav paths={paths} />
      </div>
    </div>
  );
};

export const BreadedRoute = ({ label, url, children, ...props }) => {
  const { setPath } = React.useContext(BreadedContext) || {};

  React.useEffect(() => {
    if (!setPath) return () => {};

    setPath((state) => {
      const newState = { ...state };
      newState[url] = label;
      return newState;
    });

    return () => {
      setPath((state) => {
        const oldState = { ...state };
        delete oldState[url];
        return oldState;
      });
    };
  }, [label, url, setPath]);

  return <Route {...props}>{children}</Route>;
};

BreadedRoute.defaultProps = {
  children: null,
};

BreadedRoute.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Object),
  ]),
};

function Breaded({ children }) {
  const [path, setPath] = React.useState({});

  return (
    <BreadedContext.Provider value={{ path, setPath }}>
      {children}
    </BreadedContext.Provider>
  );
}
Breaded.defaultProps = {};

Breaded.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default Breaded;
